/**
 * This file was auto-generated by Fern from our API Definition.
 */
import * as core from "../../../../core";
import { GeneratedQuery } from "./GeneratedQuery";
export const GeneratedQueryResponse = core.serialization.object({
    data: GeneratedQuery,
});
